export default __webpack_public_path__ + "static/media/14-100.7907f8ee.jpg";